import * as S from "../styles";

/* eslint-disable @typescript-eslint/no-unused-vars */
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useEffect, useState } from "react";

import AutoComplete from "@/components/hookForms/autoComplete";
import AutoCompleteMult from "@/components/hookForms/autoCompleteMult";
import { Button } from "@mui/material";
import CheckBox from "@/components/hookForms/checkbox";
import CloseIcon from "@mui/icons-material/Close";
import DatePickerMui from "@/components/hookForms/datePicker";
import IGenericResult from "@/interfaces/IGenericResult";
import IconButton from "@mui/material/IconButton";
import { format } from "date-fns";
import messages from "@/utils/messages";
import serviceClientes from "@/services/serviceCliente";
import serviceConcessionaria from "@/services/serviceConcessionaria";
import serviceInstalacao from "@/services/serviceInstalacao";
import serviceParceiro from "@/services/serviceParceiro";
import serviceRelatorio from "@/services/serviceRelatorio";
import serviceUsina from "@/services/serviceUsina";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IDialogProps {
    open: boolean;
    onClose?: any;
}

export default function DeducaoAcrescimo({ open, onClose }: IDialogProps) {
    const [usinaDataOptions, setUsinaDataOptions] = useState<IGenericResult[]>([]);
    const [instalacaoDataOptions, setInstalacaoDataOptions] = useState<IGenericResult[]>([]);
    const [clienteOptions, setClienteOptions] = useState<IGenericResult[]>([]);
    const [parceirosDataOptions, setParceirosDataOptions] = useState<IGenericResult[]>([]);
    const [concessionariaDataOptions, setConcessionariaDataOptions] = useState<IGenericResult[]>([]);
    const [isDisable, setDisable] = useState(false);

    const history = useHistory();

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            dataInicio: "",
            dataFim: "",
            idsUsinas: "",
            idsClientes: "",
            idsInstalacoes: "",
        },
    });

    useEffect(() => {
        getClienteData();
        getUsinaData();
        getInstalacaoData();
    }, []);

    const getClienteData = () => {
        serviceClientes
            .getClientes()
            .then((result) => {
                setClienteOptions(result?.data);
            })
            .catch(() => {
                setClienteOptions([]);
            });
    };

    const getInstalacaoData = async () => {
        serviceInstalacao
            .getInstalacoes()
            .then((result) => {
                setInstalacaoDataOptions(result?.data);
            })
            .catch(() => {
                setInstalacaoDataOptions([]);
            });
    };

    const getUsinaData = async () => {
        serviceUsina
            .getUsinas()
            .then((result) => {
                setUsinaDataOptions(result?.data);
            })
            .catch(() => {
                setUsinaDataOptions([]);
            });
    };

    const onSubmit = (values: any) => {
        setDisable(true);

        let inicio = new Date(values.inicio);
        let fim = new Date(values.fim);

        const newValues = {
            ...values,
            relatorioTipoID: 17,
            dataInicio: values.dataInicio ? format(values.dataInicio, "yyyy-MM-01") : "",
            dataFim: values.dataFim ? format(values.dataFim, "yyyy-MM-01") : "",
            idsUsinas: values.idsUsinas ? values.idsUsinas.join(", ") : "",
            idsClientes: values.idsClientes ? values.idsClientes.join(", ") : "",
            idsInstalacoes: values.idsInstalacoes ? values.idsInstalacoes.join(", ") : "",
        };

        delete newValues.redirecionar;

        serviceRelatorio
            .getRelatorioDeducaoAcrescimo(newValues)
            .then((result) => {
                if (result) {
                    onClose();
                    toast.success(messages.reportSucess);
                }
            })
            .catch(() => {
                toast.error(messages.reportError);
            })
            .finally(() => {
                setDisable(false);
                if (values.redirecionar) {
                    history.push("/relatorios/listagemrelatorios");
                }
            });
    };

    return (
        <div>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    <S.Title>Gerar relatório: Dedução e acréscimo</S.Title>
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose(onclose);
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent dividers>
                        <Grid item xs={12}>
                            {isDisable && (
                                <S.Loader>
                                    <img alt="Loading" src="/Loading.gif" width="40px" height="40px" />
                                </S.Loader>
                            )}
                        </Grid>

                        <S.Subtitles>Período de referência</S.Subtitles>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <DatePickerMui
                                    name="dataInicio"
                                    label="Inicio"
                                    control={control}
                                    error={errors}
                                    format="MM/yyyy"
                                    view={["month", "year"]}
                                    noDateForward
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <DatePickerMui
                                    name="dataFim"
                                    label="Fim"
                                    control={control}
                                    error={errors}
                                    format="MM/yyyy"
                                    view={["month", "year"]}
                                    noDateForward
                                />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} md={12}>
                                <AutoCompleteMult
                                    name="idsUsinas"
                                    label="Nome da Usina"
                                    options={usinaDataOptions}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <AutoCompleteMult
                                    name="idsClientes"
                                    label="Cliente"
                                    control={control}
                                    error={errors}
                                    options={clienteOptions}
                                    concatWithID={true}
                                    disabled={clienteOptions.length <= 0}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <AutoCompleteMult
                                    name="idsInstalacoes"
                                    label="Instalação"
                                    options={instalacaoDataOptions}
                                    control={control}
                                    error={errors}
                                    concatWithID={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <CheckBox
                                    name="redirecionar"
                                    label="Redirecionar para a tela de relatório"
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                        <Button
                            style={{ width: "159px", height: "44px" }}
                            onClick={() => {
                                reset();
                                onClose(onClose);
                            }}
                            color="warning"
                            variant="contained"
                        >
                            Cancelar
                        </Button>
                        <Button
                            disabled={isDisable}
                            style={{ width: "159px", height: "44px" }}
                            type="submit"
                            variant="contained"
                        >
                            Gerar
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    );
}
